<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">چاپ بارکد محصولات</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div>
                    <div class="row">

                    <b-form-group class="col-5">
                        <multiselect
                            class=""
                            placeholder="انتخاب انبار"
                            v-model="selectedStore"
                            open-direction="bottom"
                            :options="stores"
                            label="label"
                            track-by="id"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :disabled="disabled"
                        >
                            <template slot="noOptions"> موردی یافت نشد </template>
                            <template slot="noResult"> موردی یافت نشد </template>
                        </multiselect>
                    </b-form-group>
                    <div class="d-flex col-5">
                        <b-form-group>
                            <b-form-checkbox
                            :disabled="disabled"
                            class="text-center text-dark"
                            v-model="showPrice"
                            >
                        </b-form-checkbox>
                    </b-form-group>
                            <label class="mr-5" for="">نمایش قیمت در پرینت</label>
                </div>
                    </div>

                    <div class="row col-12">
                        <ProductSearch
                            class="row col-12"
                            :store="selectedStore"
                            @selectProduct="selectTheProduct"
                            @selectVariety="selectedVariety"
                        />
                    </div>
                    <button class="btn btn-success text-right item-right" @click="addVariety">افزودن</button>  
                </div>
                <div class="row mt-2">
                    <table class="table table-responsive-sm table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>محصول</th>
                                <th>تنوع</th>
                                <th>تعداد</th>
                                <th>حذف</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(variety,index) in varieties" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ variety.product_title }}</td>
                                <td>{{ variety.title }}</td>
                                <td class="d-flex justify-content-center">
                                    <b-form-input type="number" v-model="variety.customQuantity" style="max-width: 80%;"/>
                                </td>
                                <!-- <td>
                                    {{ variety.all_stores_balance.find(item => item.store_id == selectedStore.id) ? 
                                        variety.all_stores_balance.find(item => item.store_id == selectedStore.id).balance
                                    : 0 }}  
                                </td> -->
                                <td>
                                    <button  
                                        class="btn btn-sm btn-icon btn-danger text-white"  
                                        data-toggle="tooltip"  
                                        data-original-title="حذف"  
                                        style="margin-inline: 1px"  
                                        @click="deleteVariety(index)">  
                                        <i class="fa fa-trash-o"></i>  
                                    </button>  
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
                <!-- <Loading v-if="$root.isEmptyObject(items)" /> -->
            </div>
            <div class="card-footer" v-if="varieties.length > 0">
                <div class="d-flex justify-content-center align-items-center">
                    <button   
                        class="btn btn-warning text-right item-right"  
                        @click="barcodeVarieties"   
                        style="margin-inline: 5px;">  
                        چاپ بارکد  
                    </button>
                </div>
            </div>  
        </div>
    </main>
</template>
<script>
    import BarcodePrintLmpl from '@@/core/pages/BarcodePrint/BarcodePrintLmpl'
    export default {
        extends: BarcodePrintLmpl
    }
</script>
<style scoped>
    .table-responsive-sm{
        height: auto;
    }
</style>